import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

const PrivacyPolicy = () => {
  return (
    <div className="min-h-screen bg-slate-50 font-poppins selection:bg-syana-blue-100 selection:text-syana-blue-900 pt-20">
      {/* Main Content */}
      <main className="py-20 px-6">
        <motion.div 
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="max-w-4xl mx-auto bg-white p-10 lg:p-16 rounded-3xl shadow-xl shadow-slate-200/50 border border-slate-100"
        >
          <div className="space-y-4 mb-12 text-left">
            <h1 className="text-3xl lg:text-5xl font-black text-slate-900 tracking-tight leading-tight">
              Privacy Policy
            </h1>
            <p className="text-slate-400 text-sm font-medium">Last updated: October 2025</p>
          </div>

          <div className="space-y-10 text-slate-600 leading-relaxed text-base lg:text-lg text-left">
            <section className="space-y-4">
              <h2 className="text-xl font-bold text-slate-900 tracking-tight">1. Introduction</h2>
              <p>
                At Siyane Optometrists, we are committed to protecting your privacy and ensuring that your personal information is handled in a safe and responsible manner. This policy outlines how we collect, use, and protect your data.
              </p>
            </section>

            <section className="space-y-4">
              <h2 className="text-xl font-bold text-slate-900 tracking-tight">2. Information Collection</h2>
              <p>
                We collect information when you visit our branches, use our website, or book appointments. This may include your name, contact details, medical history related to eye care, and payment information.
              </p>
            </section>

            <section className="space-y-4">
              <h2 className="text-xl font-bold text-slate-900 tracking-tight">3. Use of Information</h2>
              <ul className="list-disc pl-6 space-y-2">
                <li>To provide clinical eye care services and prescriptions.</li>
                <li>To manage appointments and communication.</li>
                <li>To improve our products and customer experience.</li>
                <li>To comply with legal and medical regulations.</li>
              </ul>
            </section>

            <section className="space-y-4">
              <h2 className="text-xl font-bold text-slate-900 tracking-tight">4. Data Protection</h2>
              <p>
                We implement a variety of security measures to maintain the safety of your personal information. Your clinical data is stored in secure medical records systems accessible only to authorized personnel.
              </p>
            </section>

            <section className="space-y-4">
              <h2 className="text-xl font-bold text-slate-900 tracking-tight">5. Third-Party Disclosure</h2>
              <p>
                We do not sell, trade, or otherwise transfer your personally identifiable information to outside parties except as necessary to provide our services (e.g., insurance providers) or as required by law.
              </p>
            </section>

            <section className="space-y-4">
              <h2 className="text-xl font-bold text-slate-900 tracking-tight">6. Contact Us</h2>
              <p>
                If you have any questions regarding this privacy policy, you may contact our corporate office at info@siyaneoptom.lk.
              </p>
            </section>
          </div>
        </motion.div>
      </main>
    </div>
  );
};

export default PrivacyPolicy;
